import React from "react";
import {
  FaGem,
  FaBalanceScale,
  FaChartLine,
  FaCheckCircle,
} from "react-icons/fa";

const icons = [FaGem, FaBalanceScale, FaChartLine, FaCheckCircle];

export default function GoldValueFactorsSection({
  title,
  description,
  items = [],
}) {
  if (!title || items.length === 0) return null;

  return (
    <section className="relative overflow-hidden bg-[#fff8e8] py-14 sm:py-16 lg:py-22">
      <div className="pointer-events-none absolute left-[-220px] top-[-180px] h-[520px] w-[520px] rounded-full bg-[#f2d36a]/22 blur-3xl" />
      <div className="pointer-events-none absolute right-[-240px] bottom-[-220px] h-[580px] w-[580px] rounded-full bg-[#c89b2b]/12 blur-3xl" />

      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-6 lg:px-10">
        {/* Header */}
        <div className="mx-auto max-w-[940px] text-center">
          <div className="mx-auto mb-5 flex w-[160px] items-center justify-center gap-4">
            <span className="h-px flex-1 bg-[#c79211]" />
            <span className="h-2.5 w-2.5 rotate-45 bg-[#c79211]" />
            <span className="h-px flex-1 bg-[#c79211]" />
          </div>

          <h2 className="text-[32px] font-extrabold leading-tight tracking-[-0.04em] text-[#06152f] sm:text-[44px] lg:text-[58px]">
            {title}
          </h2>

          {description && (
            <p className="mx-auto mt-6 max-w-[780px] text-[16px] font-medium leading-8 text-[#334155] sm:text-[18px] lg:leading-9">
              {description}
            </p>
          )}
        </div>

        {/* Cards */}
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:mt-16">
          {items.map((item, index) => {
            const Icon = icons[index] || FaGem;

            return (
              <div
                key={index}
                className="group relative overflow-hidden rounded-[28px] border border-[#ead8a8] bg-white/78 p-6 shadow-[0_22px_60px_rgba(20,33,61,0.07)] backdrop-blur-md transition duration-300 hover:-translate-y-1 hover:shadow-[0_30px_80px_rgba(20,33,61,0.11)] sm:p-7 lg:p-8"
              >
                <div className="pointer-events-none absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-white via-white/55 to-transparent" />

                <div className="relative flex flex-col gap-6 sm:flex-row sm:items-start">
                  {/* Icon only */}
                  <div className="flex shrink-0 items-center justify-center">
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#f2d36a] via-[#d7a51f] to-[#b98512] shadow-[0_16px_34px_rgba(199,146,17,0.22)]">
                <Icon className="text-[27px] text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.35)]" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="relative flex-1">
                    <div className="mb-4 h-[3px] w-16 rounded-full bg-gradient-to-r from-[#c79211] to-[#f2d36a]" />

                    <h3 className="text-[23px] font-extrabold leading-tight tracking-[-0.02em] text-[#06152f] sm:text-[27px] lg:text-[31px]">
                      {item.title}
                    </h3>

                    <p className="mt-5 text-[16px] font-medium leading-8 text-[#334155] sm:text-[18px] lg:leading-9">
                      {item.text}
                    </p>
                  </div>
                </div>

                <div className="pointer-events-none absolute bottom-0 right-0 h-24 w-24 rounded-tl-full bg-[#f2d36a]/12 transition duration-300 group-hover:bg-[#f2d36a]/20" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}